const bucketName = process.env.NEXT_PUBLIC_GCS_BUCKET_NAME;
export const composeGCSUrl = (pathname) => {
  if (!pathname) return '';

  return `https://storage.googleapis.com/${bucketName}/${pathname}`;
};
